(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_n-tab-btn-list"] && !Shopify.designMode) return;
  try {
    const ntbLlist = document.querySelectorAll('.wt-ntab__list');
function syncSplide(item) {
  const splide = new Splide(item, {
      autoWidth: true,
      arrows: false,
      pagination: false,
      drag: true,
      rewind: false,
      focus: 0,
      isNavigation: true,
  });
  splide.mount();
}
ntbLlist.forEach(syncSplide);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["n-blog"] && !Shopify.designMode) return;
  try {
    // 1. 获取页面中所有匹配的轮播图容器
    var splideElements = document.querySelectorAll('.wt-nblog');
    if (!Splide) return;
    // 2. 遍历每个容器，进行独立的初始化
    splideElements.forEach(function (element) {
        const autoplay = element.dataset.wattAutoplay === 'true';
        const is_loop = element.dataset.wattLoop === 'true';
        const loop = is_loop ? 'loop' : 'slide';
        var splide = new Splide(element, { // 直接传入 DOM 元素，而非字符串选择器
            pagination: true,
            arrows: true,
            type: loop,
            drag: 'free',
            perPage: 3,
            autoplay: autoplay,
            rewind: true,
            classes: {
                pagination: 'wt-swp__pgn',
            },
            breakpoints: {
                900: {
                    perPage: 1,
                }
            },
        });
        splide.mount();
    });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["n-faq"] && !Shopify.designMode) return;
  try {
    window.addEventListener('DOMContentLoaded', function () {
  if (!window.wattcycle) return
  window.wattcycle.accordion('.wt-nfaq__btn')
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["n-swpoi"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    // 1. 获取页面中所有匹配的轮播图容器
    var splideElements = document.querySelectorAll('.wt-swpoi');
    if (!Splide) return;
    // 2. 遍历每个容器，进行独立的初始化
    splideElements.forEach(function (element) {
        const autoplay = element.dataset.wattAutoplay === 'true';
        const is_loop = element.dataset.wattLoop === 'true';
        const loop = is_loop ? 'loop' : 'slide';
        var splide = new Splide(element, {
            pagination: true,
            arrows: true,
            type: loop,
            perPage: 1,
            autoplay: autoplay,
            rewind: true,
            classes: {
                pagination: 'wt-swp__pgn',
            },
        });
        splide.mount();
    });
    var songSplideElements = document.querySelectorAll('.wt-swpoi__iswp');
    // 2. 遍历每个容器，进行独立的初始化
    songSplideElements.forEach(function (element) {
        var splide = new Splide(element, {
            pagination: true,
            arrows: false,
            type: 'slide',
            perPage: 1,
            autoplay: true,
            rewind: true,
            classes: {
                pagination: 'wt-swp__pgndot',
            },
        });
        splide.mount();
    });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["n-tab"] && !Shopify.designMode) return;
  try {
    if(!A11yTabs) return 
    const elements = document.querySelectorAll('[id^="ntab-"]');

    elements.forEach(element => {
        const id = element.id
        if(id != null) {
            new A11yTabs(`#${id} [role="tablist"]`, `#${id} [role="tabpanel"]`, 0);
        }
    });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["n-vdocm"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    // 1. 获取页面中所有匹配的轮播图容器
    var splideElements = document.querySelectorAll('.wt-nvdocm');
    if (!Splide) return;
    // 2. 遍历每个容器，进行独立的初始化
    splideElements.forEach(function (element) {
        const autoplay = element.dataset.wattAutoplay === 'true';
        const is_loop = element.dataset.wattLoop === 'true';
        const loop = is_loop ? 'loop' : 'slide';
        var splide = new Splide(element, {
            pagination: true,
            arrows: true,
            type: loop,
            drag: 'free',
            perPage: 3,
            autoplay: autoplay,
            rewind: true,
            breakpoints: {
                900: {
                    perPage: 1,
                }
            },
            classes: {
                pagination: 'wt-swp__pgn',
            },
        });
        splide.mount();
        document.dispatchEvent(new CustomEvent('wt:vdo:list:init', { detail: { root: element } }));
    });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["n-video"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__wtVideoInit) return;
  window.__wtVideoInit = true;

  var ytPlayers = new Map();
  var apiPromise = null;

  function loadYoutubeAPI() {
    if (window.YT && window.YT.Player) return Promise.resolve();
    if (apiPromise) return apiPromise;

    apiPromise = new Promise(function (resolve) {
      var prev = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = function () {
        if (typeof prev === 'function') prev();
        resolve();
      };
      var tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      document.head.appendChild(tag);
    });

    return apiPromise;
  }

  function pauseOthers(current) {
    document.querySelectorAll('video.wt-video__media').forEach(function (v) {
      if (v !== current && !v.paused) v.pause();
    });
    if (window.YT && window.YT.PlayerState) {
      ytPlayers.forEach(function (player, iframe) {
        if (iframe !== current && player.getPlayerState && player.getPlayerState() === YT.PlayerState.PLAYING) {
          player.pauseVideo();
        }
      });
    }
  }

  function playUploaded(container, media) {
    container.classList.add('is-playing');
    media.setAttribute('controls', '');
    media.muted = false;

    var played = media.play();
    if (played && played.catch) {
      played.catch(function () {
        // 浏览器拦截有声自动播放时退回静音播放，让用户自己开声音
        media.muted = true;
        media.play().catch(function () {
          container.classList.remove('is-playing');
          media.removeAttribute('controls');
        });
      });
    }
  }

  function playYoutube(container, iframe) {
    var player = ytPlayers.get(iframe);
    if (player) {
      container.classList.add('is-playing');
      player.playVideo();
      return;
    }

    container.classList.add('is-loading');
    iframe.src = 'https://www.youtube.com/embed/' + iframe.dataset.videoId +
      '?enablejsapi=1&rel=0&autoplay=1&playsinline=1&origin=' + encodeURIComponent(location.origin);

    loadYoutubeAPI().then(function () {
      player = new YT.Player(iframe, {
        events: {
          onReady: function (ev) {
            container.classList.remove('is-loading');
            container.classList.add('is-playing');
            ev.target.playVideo();
          },
          onStateChange: function (ev) {
            if (ev.data === YT.PlayerState.PLAYING) pauseOthers(ev.target.getIframe());
          }
        }
      });
      ytPlayers.set(iframe, player);
    });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.wt-video__trigger');
    if (!trigger) return;

    var container = trigger.closest('.wt-video');
    if (!container || container.classList.contains('is-loading')) return;

    var media = container.querySelector('video.wt-video__media');
    if (media) {
      playUploaded(container, media);
      return;
    }

    var iframe = container.querySelector('.wt-video__yt');
    if (iframe) playYoutube(container, iframe);
  });

  document.addEventListener('play', function (e) {
    if (e.target.classList && e.target.classList.contains('wt-video__media')) {
      pauseOthers(e.target);
    }
  }, true);

  document.addEventListener('ended', function (e) {
    var media = e.target;
    if (!media.classList || !media.classList.contains('wt-video__media')) return;

    var container = media.closest('.wt-video');
    if (container) container.classList.remove('is-playing');
    media.removeAttribute('controls');
    media.load();
  }, true);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["p-swp"] && !Shopify.designMode) return;
  try {
    function initNormalTabProduct() {
    const sections = document.querySelectorAll('.wt-pswp');
    sections.forEach(function (section) {
            if (!Splide) return;
            const splide = new Splide(section, {
                pagination: true,
                arrows: true,
                type: 'slide',
                drag: 'free',
                perPage: 3,
                breakpoints: {
                    900: {
                        perPage: 1,
                    },
                },
                classes: {
                    pagination: 'wt-swp__pgn',
                },
            });
            splide.mount();
    });
}

window.addEventListener('DOMContentLoaded', initNormalTabProduct);
  } catch(e) { console.error(e); }
})();

})();
